import { useGetLocale } from "@refinedev/core";
import React, { useMemo } from "react";
import { ProductList } from "../components/ProductList";
import {
  getStandartInventoryColumns,
  TabColumnInfo,
} from "../components/standartListData";
import { useTranslation } from "../../../../hooks/useTranslation";
import { Alert, Typography } from "@mui/material";

type ProductListWrapperProps = {
  tabInfo: TabColumnInfo;
};

const ProductListWrapper: React.FC<ProductListWrapperProps> = (
  props: ProductListWrapperProps,
) => {
  const { tabInfo } = props;
  const locale = useGetLocale();
  const { translate } = useTranslation();

  const baseColumns = useMemo(() => {
    return getStandartInventoryColumns(translate, locale());
  }, [translate, locale]);

  const dynamicColumns = useMemo(() => {
    if (tabInfo.columns) {
      return baseColumns.filter((column) =>
        tabInfo.columns!.includes(column.field),
      );
    } else {
      return baseColumns;
    }
  }, [tabInfo, baseColumns]);

  return (
    <>
      {tabInfo.hasDescription && (
        <Alert severity="info">
          <Typography variant="body2">
            {translate(
              `pages.inventoryManagement.inventory.descriptions.${tabInfo.path}`,
            )}
          </Typography>
        </Alert>
      )}
      <ProductList
        columns={dynamicColumns}
        storeProductStatus={tabInfo.storeProductStatus}
        marketplaceProductStatus={tabInfo.marketplaceProductStatus}
        amazonListingItemStatus={tabInfo.amazonListingItemStatus}
        hasRowSelection={tabInfo.hasRowSelection}
      />
    </>
  );
};

export default ProductListWrapper;
